import { EstimateIcon } from '../../assets/CustomIcons/EstimateIcon';
import { WorkspaceEstimationType } from '../../types/Workspace';
import { TaskEstimateLongMapping, TaskEstimateMapping } from '../TaskTable/helpers/helper';

export enum TaskEstimateComponentType {
  table,
  dropdown,
}

export type TaskEstimateLabelProps = {
  estimate?: number;
  component: TaskEstimateComponentType;
  estimationType: WorkspaceEstimationType;
  className?: string;
};

export const TaskEstimateLabel = (props: TaskEstimateLabelProps) => {
  const { estimate, component, className } = props;

  // estimate is an ordinal into the workspace's scale, not a raw point value.
  // Writers outside the UI can store an off-scale value, which has no label —
  // render it as absent rather than as a pill with a triangle and no number (#2729).
  const label =
    estimate === undefined
      ? undefined
      : component === TaskEstimateComponentType.table
        ? TaskEstimateMapping(props.estimationType)[estimate]
        : TaskEstimateLongMapping(props.estimationType)[estimate];

  return estimate && label ? (
    <div
      className={`flex gap-1 px-2 py-0.5 bg-neutral-200 rounded justify-center items-center text-brand-grey-dark text-sm font-normal leading-tight ${className}`}
    >
      <EstimateIcon className="text-neutral-900" />
      {label}
    </div>
  ) : (
    <div className="text-neutral-700">No estimate</div>
  );
};
